













































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
import { Route } from "vue-router";
import { GenericSearchForm, BlockSearchForm, TransactionSearchForm, AccountSearchForm } from "@/components/search";
import { BlockService, TransactionService, AccountService } from "@/services";
import {
  ISortParameters,
  IBlock,
  IAccount,
  ITransaction,
  IMeta,
  ITransactionSearchParams,
  IAccountSearchParams,
  IBlockSearchParams,
} from "@/interfaces";
import { inputProcessor } from "@/utils";
import store from "@/store";

Component.registerHooks(["beforeRouteEnter", "beforeRouteUpdate"]);

@Component({
  components: {
    GenericSearchForm,
    BlockSearchForm,
    TransactionSearchForm,
    AccountSearchForm,
  },
  computed: {
    ...mapGetters("ui", ["nightMode"]),
    ...mapGetters("network", ["supply"]),
  },
})
export default class AdvancedSearchPage extends Vue {
  private types: object = {
    transaction: {
      searchService: TransactionService.search,
    },
    block: {
      searchService: BlockService.search,
    },
    wallet: {
      searchService: AccountService.search,
    },
  };

  private data: any[] | null = null;
  private meta: any | null = null;
  private currentPage = 1;
  private searchTypes: string[] = Object.keys(this.types);
  private selectedType = "transaction";
  private searchParams: ITransactionSearchParams | IBlockSearchParams | IAccountSearchParams = {};
  private submitted = false;
  private supply: number;
  private lastFormChange = 0;

  get showPagination(): boolean {
    return this.meta && this.meta.pageCount > 1;
  }

  get searchService() {
    return this.types[this.selectedType].searchService;
  }

  @Watch("currentPage")
  public onCurrentPageChanged() {
    this.changePage();
  }

  public async beforeRouteUpdate(to: Route, from: Route, next: (vm?: any) => void) {
    this.setData(null);
    this.setMeta(null);

    try {
      const data = await this.searchService(this.searchParams, Number(to.params.page));
      // this.currentPage = Number(to.params.page);
      // this.setMeta(meta);
      next();
    } catch (e) {
      next({ name: "404" });
    }
  }

  public setMeta(meta: IMeta) {
    this.meta = meta;
  }

  public onPageChange(page: number) {
    this.currentPage = page;
  }

  public changePage() {
    if (this.currentPage !== Number(this.$route.params.page)) {
      // @ts-ignore
      this.$router.push({
        name: "search",

      });
    }
  }

  private async onFormChange(input: { name: string; value: string }) {
    let processedName = input.name;
    const processedInput = await inputProcessor(input.name, input.value);

    if (this.lastFormChange > processedInput.ts) {
      return;
    }

    // Remove field from search params when input is empty
    if (processedInput.value !== 0 && !processedInput.value) {
      this.removeFromSearchParams(input.name);
      return;
    }

    // Create nested object value for to/from type params
    if (input.name.includes("-")) {
      const [parent, child] = input.name.split("-");
      processedName = parent;
      processedInput.value = { ...this.searchParams[parent], [child]: processedInput.value };
    }

    this.searchParams = { ...this.searchParams, [processedName]: processedInput.value };
    this.lastFormChange = processedInput.ts;
  }

  private removeFromSearchParams(name: string): void {
    if (name.includes("-")) {
      const [parent, child] = name.split("-");
      delete this.searchParams[parent][child];

      if (!Object.keys(this.searchParams[parent]).length) {
        delete this.searchParams[parent];
      }

      return;
    }

    delete this.searchParams[name];
  }

  private async search(): Promise<void> {
    this.setMeta(null);
    this.setData(null);
    this.currentPage = 1;
    this.submitted = true;

    try {
      const data = await this.searchService(this.searchParams);
      const blocks = [];
      blocks.push(data);
      console.log(data);
      //this.setMeta(meta);
      this.setData(blocks);
    } catch {
      this.setData([]);
    }
  }

  private onSearchTypeChange(event: any): void {
    this.setMeta(null);
    this.setData(null);
    this.searchParams = {};
    this.submitted = false;
    this.selectedType = event.target.value;
  }

  private setData(data: ITransaction[] | IBlock[] | IAccount[]) {
    this.data = data;
  }

}
